import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as Api from '@vi-iot/client';

import { NoteActions } from './note.actions';

@Injectable()
export class NoteEffects {
  getNote$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NoteActions.getNote),
      switchMap((action) =>
        this.api.getNote(action.installationId).pipe(
          map((payload) => NoteActions.getNoteSuccess(payload)),
          catchError((err) => of(NoteActions.getNoteError(err)))
        )
      )
    );
  });

  addNote$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NoteActions.addNote),
      switchMap((action) =>
        this.api.createNote(action.installationId, action.note).pipe(
          map(() => NoteActions.addNoteSuccess()),
          catchError((err) => of(NoteActions.addNoteError(err)))
        )
      )
    );
  });

  deleteNote$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(NoteActions.deleteNote),
      switchMap((action) =>
        this.api.deleteNote(action.installationId).pipe(
          map(() => NoteActions.deleteNoteSuccess()),
          catchError((err) => of(NoteActions.deleteNoteError(err)))
        )
      )
    );
  });

  constructor(private api: Api.VitoguideBackendSettingsApi, private actions$: Actions) {}
}
